import React from "react";
import { Paper, Typography } from "@mui/material";

const Footer: React.FC = () => {
  return (
    <Paper
      component="footer"
      square
      elevation={3}
      sx={{
        width: "100%",
        p: 2,
        color: "white",
        textAlign: "center",
        flexShrink: 0,
        marginTop: "3em",
      }}
    >
      <Typography variant="body2">© 2025 EdSource</Typography>
    </Paper>
  );
};

export default Footer;
